<template lang="pug">
  .permission
    .auth-form.tac(@keyup.enter="handleValidator")
      p
        img(:src="this.$store.getters.getVideoInfo.logo")
      p {{this.$store.getters.getVideoInfo.video_name}}
      el-input(v-model="password", type="password", maxlength="10", placeholder="请输入密码", ref="passwordInput" )
      el-button(type="primary", @click="handleValidator") 确 定
</template>

<script>
import AUTH from '@/utils/cookie'
import { mapGetters } from 'vuex'

export default {
  name: 'Permission',
  computed: {
    ...mapGetters(['getCurrentSceneName']),
  },
  data() {
    return {
      loading: false,
      password: '',
      videoId: '',
      redirectUrl: '',
    }
  },
  created() {
    this.videoId = this.$route.query.videoid
  },
  mounted() {
    const panokey = AUTH.getCookie('panokey')
    this.redirectUrl = '/?videoid=' + this.$store.getters.getVideoId
    if (panokey) {
      this.$router.push(this.redirectUrl)
    }
  },
  methods: {
    handleValidator() {
      if (this.password !== this.$store.getters.getVideoInfo.passkey) {
        this.$vgo.tip('密码错误！', 'error')
        this.clear()
        return
      }
      // 24小时有效
      let nonce = Math.random()
        .toString(36)
        .substr(2, 15)
      AUTH.setCookie('panokey', nonce, 24 * 60)

      setTimeout(() => {
        this.$router.push(this.redirectUrl)
      }, 200)
    },
    clear() {
      this.password = ''
      this.$refs.passwordInput.focus()
      this.loading = false
    },
  },
}
</script>

<style lang="stylus">
.permission
  position fixed
  left: 0
  top: 0
  right: 0
  bottom: 0
  background-color: skyblue
  z-index: 1000
  .auth-form
    position: absolute
    left: 50%
    top: 40%
    transform: translate(-50%, -50%)
    width: 300px
    height: 300px
    padding: 15px
    p
      color: #fff
      font-size: 18px
    .el-button
      margin: 15px 0 0
      width: 100%
    .el-input
      margin: 15px 0 0
    img
      height: 200px
      margin-bottom: 10px
</style>
